<template>
  <div class="mt-5 mt-md-3">
    <sakali-h title="Transferliste"/>
    <!-- Filter -->
    <div class="card-sakali container ps-0 mt-2">
      <!-- Position -->
      <div class="row pt-1">
        <div class="col-3 col-md-2 text-end pe-0">
          <fas icon="arrows-alt" style="width: 1.1em"></fas>
          Position:
        </div>
        <div class="col-9">
                <span v-for="pos in ['TOR', 'ABW', 'MIT', 'STU']"
                      :key="pos"
                      class="border border-light py-1 px-2"
                      :class="{'bg-sakali-primary': selectedPosition==pos}"
                      @click="selectedPosition=pos">
                    {{ pos }}
                </span>
        </div>
      </div>
      <!-- Alter -->
      <div class="row mt-3">
        <div class="col-3 col-md-2 text-nowrap text-end">
          <fas icon="birthday-cake" style="width: 1.1em"></fas>
          Alter:
        </div>
        <div class="col-9">
          <vue-slider
              v-model="selectedAgeRange"
              contained="true"
              :data="ageRange"
              :marks="true"
              tooltip="none"
              :enable-cross="false"
              :lazy="true"/>
        </div>
      </div>
      <!-- Stärke -->
      <div class="row mt-2">
        <div class="col-3 col-md-2 pt-3 text-nowrap text-end pe-0">
          <fas icon="dumbbell" style="width: 1.1em"></fas>
          Stärke:
        </div>
        <div class="col-9 py-3">
          <vue-slider
              v-model="selectedStrengthRange"
              contained="true"
              :data="strengthRange"
              tooltip="none"
              :marks="true"
              :enable-cross="false"
              :lazy="true"/>
        </div>
      </div>
    </div>
    <div v-if="transferRequests.length > 0"
         class="card-sakali px-1 px-md-2 mt-4">
      <table class="table table-sm">
        <tr v-for="tr in transferRequests" :key="tr.id">
          <td class="py-1 px-0 small align-middle">{{ tr.deadline | shortDate }}<br>{{
              tr.deadline |
                  shortTime
            }}
          </td>
          <td class="d-md-none py-0 text-start text-truncate">
            <player-avatar
                primary-color="tr.player.team.primaryColor"/>&nbsp;{{ tr.player.givenName[0] }}.&nbsp;{{ tr.player.surName }}
            <span class="d-md-none"><br/>{{ tr.minimalBid | kies }}</span>
          </td>
          <td class="d-none d-md-table-cell py-0 text-start text-truncate align-middle">
            <player-avatar primary-color="tr.player.team.primaryColor"/>&nbsp;
            {{ tr.player.name }}
          </td>
          <td class="d-none d-md-table-cell align-middle">{{ tr.minimalBid | kies }}</td>
          <player-strength-and-age-table-cell :player="tr.player"/>
          <td class="text-center align-middle py-0 px-0 text-success"
              :class="{'text-danger' : (tr.bidCount > 0)}">
            {{ tr.bidCount }}<br>
            Bieter
          </td>
          <td v-if="bid(tr.id)"
              :set="amount = bid(tr.id).amount"
              class="d-inline-flex pe-0">
            <div class="text-center">
              <span class="small text-nowrap">Dein Gebot<br></span>
              <span class="text-center align-text-top p-0 m-0 font-weight-bold">
                                {{ amount | kies }}
                            </span>
            </div>
            <div class="ps-1 pe-0 text-end" @click="bidSubmitted(tr.id, 0)">
              <span class="btn btn-sakali py-0 text-light bg-sakali-primary px-1 me-0">&times;</span>
            </div>
          </td>
          <td v-else
              class="text-end pe-0 ps-0 align-middle">
            <button type="button"
                    class="btn btn-sm btn-sakali mx-0 px-2"
                    data-toggle="modal"
                    :data-target="'#bidInput-' + tr.id">
              Bieten
            </button>
            <input-modal :id="'bidInput-' + tr.id"
                         :instructions="'Minimalgebot: ' + tr.minimalBid"
                         class="my-5"
                         type="number"
                         :title="'Gebot für ' + tr.player.givenName + ' ' + tr.player.surName"
                         @submit="bidSubmitted(tr.id, $event)"/>
          </td>
        </tr>
      </table>
    </div>
    <div v-else
         class="text-center font-weight-bold mt-4 p-4">
      Es gibt aktuell keine Transfers,<br> die diesem Filter entsprechen.
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import sakaliApi from '../../sakali-api'
import VueSlider from 'vue-slider-component'
import InputModal from '../InputModal'
import PlayerStrengthAndAgeTableCell from "../PlayerStrengthAndAgeTableCell";
import PlayerAvatar from "../PlayerAvatar";
export default {
  data() {
    return {
      transferRequests: [],
      myTransferBids: [],
      selectedPosition: 'TOR',
      selectedAgeRange: [this.minAge, this.maxAge],
      selectedStrengthRange: [60, 100]
    }
  },
  computed: {
    ...mapGetters(['configuration', 'user']),
    minAge() {
      return this.configuration.minPlayerAge
    },
    maxAge() {
      return this.configuration.maxPlayerAge
    },
    minAgeWithoutStrengthReduction() {
      return this.configuration.minAgeWithoutStrengthReduction
    },
    maxAgeWithoutStrengthReduction() {
      return this.configuration.maxAgeWithoutStrengthReduction
    },
    ageRange() {
      return [...Array(this.maxAge - this.minAge + 1).keys()].map(a => {
        return a + this.minAge
      })
    },
    strengthRange() {
      return [...Array(11).keys()].map(s => {
        return s * 10
      })
    }
  },
  methods: {
    ...mapActions(['messageAction', 'handleErrorAction', 'refreshUserAction']),
    bid(trId) {
      let res = null
      this.myTransferBids.forEach(bid => {
        if (bid.transferId == trId) {
          res = bid
        }
      })
      return res
    },
    reloadTransferRequests() {
      sakaliApi.get(
          '/transfers', {
            params: {
              pos: this.selectedPosition,
              minage: this.selectedAgeRange[0],
              maxage: this.selectedAgeRange[1],
              minstrength: this.selectedStrengthRange[0],
              maxstrength: this.selectedStrengthRange[1]
            }
          }).then(response => {
        // store the requests
        this.transferRequests = response.data
        // load my transferbids
        sakaliApi.get('/transfers/mybids').then(response => {
          // store my bids
          this.myTransferBids = response.data
          this.refreshUserAction()
        }).catch(error => {
          this.handleErrorAction(error)
        })
      }).catch(error => {
        this.handleErrorAction(error)
      })
    },
    bidSubmitted(trId, bid) {
      window.$('#bidInput-' + trId).modal('hide')
      if (bid > this.user.balance)
        this.messageAction('Du hast nicht genug Kies für dieses Gebot')
      else {
        let payload = {
          key: 'bid',
          value: bid
        }
        sakaliApi.post('/transfers/' + trId + '/bids', payload, {
          headers: {
            'Content-type': 'application/json',
          }
        }).then(() => {
          this.reloadTransferRequests()
        }).catch(error => {
          this.handleErrorAction(error)
        })
      }
    }
  },
  watch: {
    selectedPosition() {
      this.reloadTransferRequests()
    },
    selectedAgeRange() {
      this.reloadTransferRequests()
    },
    selectedStrengthRange() {
      this.reloadTransferRequests()
    }
  },
  mounted() {
    this.reloadTransferRequests()
  },
  components: {
    PlayerAvatar,
    VueSlider,
    InputModal,
    PlayerStrengthAndAgeTableCell
  }
}
</script>

<style>
.vue-slider-dot-handle {
  border-color: white;
  background-color: #fda642;
  border: 2px solid white;
}
.vue-slider-process {
  background-color: #fda642;
}
.vue-slider-dot-tooltip-inner {
  color: #fda642;
}
.vue-slider-mark-step-active {
  box-shadow: 0 0 0 2px #fda642 !important;
}
</style>
